import React, { useState } from 'react'

import { Circle, Warning } from '@mui/icons-material'
import {
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { format, parseISO } from 'date-fns'

import { SubmittedWorklog } from '../../actions/submittableWorkLogsSelector'
import { createStyles } from '../../styles'

const styles = createStyles({
  block: {
    paddingX: 1,
    paddingY: 2,
  },
  circleIcon: {
    fontSize: 8,
  },
  worklogText: {
    marginRight: 2,
  },
})

interface WorklogsListProps {
  worklogs: SubmittedWorklog[]
}

const WorklogsList = ({ worklogs }: WorklogsListProps) => {
  return (
    <List disablePadding>
      {worklogs.map((worklog) => (
        <ListItem key={worklog.id} disablePadding>
          <ListItemIcon>
            <Circle sx={styles.circleIcon} />
          </ListItemIcon>
          <ListItemText>
            <Box component="span" sx={styles.worklogText}>
              {format(parseISO(worklog.dateStarted), 'd.M.yyyy HH:mm')}
            </Box>
            <Box component="span" sx={styles.worklogText}>
              {worklog.issue}
            </Box>
            <Box component="span" sx={styles.worklogText}>
              {worklog.comment}
            </Box>
          </ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

interface FtAndJiraInSyncProps {
  allWorklogsInJira: boolean
  worklogsNotInJira: SubmittedWorklog[]
  worklogsDiffFromJira: SubmittedWorklog[]
  worklogsInJiraLoading: boolean
}

export const FtAndJiraInSync = ({
  allWorklogsInJira,
  worklogsNotInJira,
  worklogsDiffFromJira,
  worklogsInJiraLoading,
}: FtAndJiraInSyncProps) => {
  const [opened, setOpened] = useState(false)

  if (worklogsInJiraLoading)
    return (
      <IconButton disabled>
        <CircularProgress size={25} />
      </IconButton>
    )

  if (allWorklogsInJira) return null

  return (
    <Box>
      <Tooltip
        title="Some submitted worklogs are not correctly saved in Jira."
        placement="top"
      >
        <IconButton onClick={() => setOpened(true)}>
          <Warning />
        </IconButton>
      </Tooltip>

      <Dialog open={opened} onClose={() => setOpened(false)}>
        <Box sx={styles.block}>
          <strong>
            Some submitted worklogs are not correctly saved in Jira.
          </strong>
        </Box>
        <Box sx={styles.block}>
          <strong>Worklogs not in Jira at all:</strong>
          <WorklogsList worklogs={worklogsNotInJira} />
        </Box>
        <Box sx={styles.block}>
          <strong>Worklogs in Jira, but with different data:</strong>
          <WorklogsList worklogs={worklogsDiffFromJira} />
        </Box>
      </Dialog>
    </Box>
  )
}
